export class Controller {

    /** @ngInject */
    constructor(AccountsResource) {
        this.AccountsResource = AccountsResource;
    }

    $onInit() {
    }

    change() {
        this.isSaving = true;
        this.AccountsResource
            .changeOwner(this.resolve.companyId, this.resolve.accountId, this.resolve.newOwner)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/change/change-account-owner.controller.js